import { Dispatch } from 'react';
import { networkCall, apiBaseUrl } from '../../utils/networkCall';
import isEmpty from 'lodash/isEmpty'; 

export const FLOWS_LOADING = "FLOWS_LOADING";
export const FLOWS_SUCCESS = "FLOWS_SUCCESS";
export const FLOWS_FAILED = "FLOWS_FAILED";
export const FLOWS_ADD_MORE = "FLOWS_ADD_MORE";

export const FLOW_DELETE = "FLOW_DELETE";
export const FLOW_UPDATE = "FLOW_UPDATE";
export const FLOWS_DUPLICATE = "FLOWS_DUPLICATE";

export const FLOWS_FILTER_LOADING = "FLOWS_FILTER_LOADING";
export const FLOWS_FILTER_SUCCESS = "FLOWS_FILTER_SUCCESS";

export const CLEAR_FLOW_STATUS = "CLEAR_FLOW_STATUS";
export const FLOWS_UPDATE_FILTERS = "FLOWS_UPDATE_FILTERS";
export const CLEAR_ALL_FLOWS = "CLEAR_ALL_FLOWS";

export const loadExistingFLows = (limit: number, offset: number, searchString: any = undefined, service_id: any = undefined, status: any = undefined, sort:string = "modified_at", order:string = "desc", fetchOne: boolean = false, totalCount: number = 0, selectedChannels: string[], selectedStatus: string[], selectedSort: string, type:string[]) => {
    return (dispatch:Dispatch<any>) => {

        let loadingType:string = FLOWS_LOADING;
        let successType:string = FLOWS_SUCCESS;
        let failedType :string = FLOWS_FAILED;

        // if(searchString !== undefined || service_id !== undefined || status !== undefined){
        //     loadingType = FLOWS_FILTER_LOADING;
        //     successType = FLOWS_FILTER_SUCCESS;
        // }

        if(totalCount){
            loadingType = FLOWS_FILTER_LOADING;
            successType = FLOWS_FILTER_SUCCESS;
        }

        if(!fetchOne){
            dispatch({ type: loadingType, payload: {}});
            dispatch({ type: FLOWS_UPDATE_FILTERS, payload: { searchString, selectedChannels, selectedStatus, selectedSort }})
        }else{
            successType = FLOWS_ADD_MORE;
        }

        let url: string = `/flowbuilder?limit=${limit}&offset=${offset}&sort=${sort}&order=${order}`;
        if(searchString){
            url = url + `&name=${searchString||""}`;
        }
        if(service_id){
            url = url + `&service_id=${service_id||""}`;
        }
        if(status){
            url = url + `&status=${status||""}`;
        }
        
        // set trigger type filters
        if(type){
            url = setTypefilters(type, url);
        }

        networkCall("get", url, apiBaseUrl.baseUrl)
        .then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                dispatch({ type: successType, payload: {respose: res}});
            }else{
                dispatch({ type: failedType, payload: {error: res}});
            }
        }).catch((error)=>{
            if(error?.response?.data){
                dispatch({ type: failedType, payload: {error: error.response.data}});
            }
        });

    }
}

const setTypefilters = (type: string[], url: string) => {
    if (type.includes('webhook')) {
        url = url + `&webhook=1`;
    }

    if (type.includes('voice')) {
        url = url + `&voice_call=1`;
    }

    if (type.includes('whatsapp')) {
        url = url + `&wa_call=1`;
    }

    return url;
}

export const deleteFlow = (id:number) => {
    return (dispatch:Dispatch<any>) => {
        networkCall("delete", `/flowbuilder/delete`, apiBaseUrl.baseUrl, true, true, {id})
        .then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                dispatch({ type: FLOW_DELETE, payload: {id: id, message: res.message}});
            }else{
                dispatch({ type: FLOWS_FAILED, payload: {error: res}});
            }
        }).catch((error)=>{
            if(error?.response?.data){
                dispatch({ type: FLOWS_FAILED, payload: {error: error.response.data}});
            }
        });
    }
}

export const updateFlow = (id:number, operation: string, name: string) => {
    return (dispatch:Dispatch<any>) => {
        let status = "0";
        if(operation === "resume"){
            status = "1";
        }
        networkCall("put", `/flowbuilder/pause-resume`, apiBaseUrl.baseUrl, true, true, {id, status, name})
        .then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                dispatch({type: FLOW_UPDATE, payload: {id, status, message: res.message}});
            }else{
                dispatch({ type: FLOWS_FAILED, payload: {error: res}});
            }
        }).catch((error)=>{
            if(error?.response?.data){
                dispatch({ type: FLOWS_FAILED, payload: {error: error.response.data}});
            }
        });
    }
}

export const duplicateFlow = (id:number, name: string, cb: (res:any,success:boolean) => void) => {
    return (dispatch:Dispatch<any>) => {
        networkCall("post", `/flowbuilder/duplicate`, apiBaseUrl.baseUrl, true, true, {id, name})
        .then((res:any)=>{
            if(res.error && isEmpty(res.error)){
                res.data[0] = {
                    ...res.data[0],
                    isNewFlow : true
                }
                console.log("RES",res);
                dispatch({type: FLOWS_DUPLICATE, payload: {response:res} });
                cb(res,true);
            }else{
                dispatch({ type: FLOWS_FAILED, payload: {error: {}}});
                cb(res,false);
            }
        }).catch((error)=>{
            if(error?.response?.data){
                dispatch({ type: FLOWS_FAILED, payload: {error: {}}});
                cb({error: error.response.data},false);
            }
        });
    }
}

export const clearStatusState = () => {
    return (dispatch:Dispatch<any>) => {
        dispatch({type: CLEAR_FLOW_STATUS, payload: {}});
    }
}

export const clearWholeDate = () => {
    return (dispatch:Dispatch<any>) => {
        dispatch({type: CLEAR_ALL_FLOWS, payload: {}});
    }
}